<template>
    <div>
      <patent-status-list></patent-status-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  